import { trustedRequest, putRequest } from 'utils/request';

export const getLists = () => trustedRequest('/api/catalog/lists');

export const catalogSearch = (page: number, size: number = 9) =>
  putRequest(`/api/catalog/search?page=${page}&size=${size}`);

export const dashboardCategories = () => trustedRequest(`/api/dashboard/categories`);
